import { ReactNode, forwardRef } from 'react';
import { cx } from '@linaria/atomic';
import type { CommonHTMLButtonAttributes } from '@frontend/types';
import { NakedButton } from '../../../naked/naked-button.component';
import { tabItemStyle } from '../common-styles';

type Props = CommonHTMLButtonAttributes & {
  children: ReactNode;
  id: string;
  trackingId?: string;
  isActive: boolean;
};

export const Tab = forwardRef<HTMLButtonElement, Props>(({ children, className, isActive, ...rest }: Props, ref) => {
  return (
    <NakedButton ref={ref} className={cx(tabItemStyle, className)} {...rest}>
      {children}
    </NakedButton>
  );
});
